module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-fieldset', {
    attrs: {
      "label-text-align": "right",
      "label-cols": _vm.labelCols,
      "label": _vm.label + ':',
      "horizontal": "",
      "state": _vm.veeState,
      "feedback": _vm.veeFeedBack
    }
  }, [(_vm.static || _vm.isReadOnly) ? _c('div', {
    staticClass: "text-left static-field",
    domProps: {
      "innerHTML": _vm._s(_vm.getStaticValue())
    }
  }) : _c('div', [(_vm.type === 'simpledate') ? _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.vvalidate),
      expression: "vvalidate"
    }],
    attrs: {
      "type": "date",
      "name": _vm.field,
      "state": _vm.veeState,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'date') ? _c('datepicker', {
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState,
      "clear-button": _vm.hasClearButton,
      "clear-button-icon": "fa fa-times",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar",
      "inputClass": "dateinput",
      "bootstrapStyling": true
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, true)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'daterange') ? _c('daterange', {
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, true)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'boolean' && _vm.hasNull) ? _c('b-form-select', {
    staticClass: "float-right text-right",
    attrs: {
      "name": _vm.field,
      "options": _vm.booleanOptionList,
      "state": _vm.veeState,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, true)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'boolean') ? _c('b-form-checkbox', {
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : ((_vm.optionList !== null || _vm.optionListApiUrl !== null) && _vm.finalOptionList.length) ? _c('multiselect', {
    attrs: {
      "track-by": "value",
      "name": _vm.field,
      "options": _vm.finalOptionList,
      "state": _vm.veeState,
      "label": "text",
      "showLabels": false,
      "data-vv-name": _vm.field,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, true)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'textarea') ? _c('b-form-textarea', {
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState,
      "disabled": _vm.isReadOnly,
      "rows": 4
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, false)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  }) : (_vm.type === 'money') ? _c('b-input-group', {
    attrs: {
      "left": "€"
    }
  }, [_c('b-form-input', {
    staticClass: "float-right",
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState,
      "type": "number",
      "step": "0.01",
      "data-number-to-fixed": "2",
      "data-number-stepfactor": "100",
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, false)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, _vm._n($$v))
      },
      expression: "rec[field]"
    }
  })], 1) : _c('b-form-input', {
    staticClass: "float-right",
    attrs: {
      "name": _vm.field,
      "state": _vm.veeState,
      "type": _vm.type,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": function($event) {
        _vm.onInput($event, false)
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.rec[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.rec, _vm.field, $$v)
      },
      expression: "rec[field]"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6396567e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailField.vue
// module id = 708
// module chunks = 1